module.exports = "/assets/data/5d8c380c6ca80938bcb50522c9112e8c-CA24.data.json";